export const source = () => {
  const result = [
    {
      title: "አዘጋጆች",
      details: {
        html: `
        <h4>አዘጋጆች</h4>
        <ol>
        <li>ዶ/ር መንግሥቱ ገብረዮሐንስ መንገሻ-የአጥንትና መገጣጠሚያ ስፔሻሊስት፣ የጀርባ አከርካሪ ሰብ ስፔሻሊት ሃኪም</li>
        
        <li>ዶ/ር ኤፍሬም ገ/ሐና አደም- የአጥንትና መገጣጠሚያ ስፔሻሊስት፤ የከፍተኛ አደጋዎች እና የመገጣጠሚያ ቅየራ ሰብ ስፔሻሊስት ሃኪም</li>
      </ol>
      <div style="padding-left: 30%;">
      <p>ሀዋሳ፣ ኢትዮጵያ<br> 2016 G.C</p>
      </div>
      <table>
  <tr>
    <th>አፕሊኬሽኑን የሰራው</th>
    <th>ስፖንሰር</th>
    </tr>
    <tr>
    <td>ኤርሚያስ ኩራባቸው<br>+251 92 250 0469</td>
    <td>AO Alliance</td>
    </tr>
    </table>
    `,
      },
      image: "bosad_poster",
    },
    {
      title: "የአዘጋጆቹ መብት",
      details: {
        html: `
        <h3>የአዘጋጆቹ መብት በህግ የተጠበቀ ነው፤ 2016 ዓ.ም</h3>
      <h4>© All right reserved 2023G.c</h4>
      <p>
        ኢትዮጵያ ውስጥ ታትሟል።</p>
        <p style="padding-right: 10px;">
        የቅጅና ተዛማጅ መብቶች ጥበቃ አዋጅ ቁጥር 410/1996 በአዋጅ ቁጥር 872/2007 እንደተሻሻለ ከሚፈቅደዉ ዉጭ ማንኛውም የዚህ እትም በሙሉ ወይም በከፊል በማንኛውም መልኩ እንደገና ሊታተም ወይም ሊሰራጭ ወይም በመረጃ ቋት ውስጥ ሊቀመጥ ወይም ጥቅም ላይ ሊዉል አይችልም። ይህ ጥራዝ ባለቤትነቱ በኢትዮጵያ የ”BOSAD” የምርምር ቡድን ሲሆን በጽሁፍ የተረጋገጠ ፈቃድ እስካልተሰጠ ድረስ ጥራዙን በሙሉም ይሁን በከፊል እንደ ራስ አስመስሎ መጠቀም አይቻልም።
      </p>
      <p  style="padding-right: 10px;">
      ይህ በትምህርት ገበታ ላይ ያሉ ልጆች ላይ የሚደርስ ያልታሰበ የመዉደቅ አደጋን የመከላከያ ስልት እና የቅድመ ሆስፒታል ህክምናን አስመልክቶ የተዘጋጀዉ ጥራዝ የቦሳድ (BOSAD) የጥናት ቡድንን በመወከል የተዘጋጀ ሲሆን መረጃዎቹም የተቀናበሩት ከዚሁ አገር አቀፍ የጥናት ሪፖርት ነዉ።
      </p>
      <p>ዲዛይን እና ኢሉስትሬሽን፡- ደስ አድቨርታይዚንግ</p>
      <p>አስተያየት ለመስጠት ከፈለጉ የሚከተለዉን አድራሻ ይጠቀሙ። ዶ/ር መንግስቱ ገብረዮሃንስ፣ ስልክ ቁጥር - 0910120423 ወይም ደግሞ ኢሜል - mengistugmengesha@gmail.com</p>
    `,
      },
    },
    {
      title: "ምስጋና",
      details: {
        html: `
        <p>
        ለ “BOSAD” የምርምር ቡድን እና ወደ ተለያዩ ቋንቋዎች እንዲተረጎም ላደረጉት የቋንቋ ልሂቃን ታላቅ ምስጋና ይገባቸዋል። ለእነ ዶ/ር. ህዝቅያስ ካሳዬ፣ አርአያ ጥላሁን፣ ቶላሳ ዲንሳ፣ አብዱላሂም ሙሀመድ፣ እና ወይዘሮ ኤደን አለሙ (የቦሳድ የጥናት አስተባባሪ) ሰነዱን በመከለስ ላበረከቱት ጉልህ አስተዋጽኦ ልዩ እውቅና እናቀርባለን።
      </p>
      <ol>
        <li>
        ዶ/ር መንግሥቱ ገብረዮሐንስ መንገሻ-የአጥንትና መገጣጠሚያ ስፔሻሊስት፣ የጀርባ አከርካሪ ሰብ ስፔሻሊት ሃኪም
        </li>
        
        <li>
        ዶ/ር ኤፍሬም ገ/ሐና አደም- የአጥንትና መገጣጠሚያ ስፔሻሊስት፤ የከፍተኛ አደጋዎች እና የመገጣጠሚያ ቅየራ ሰብ ስፔሻሊስት ሃኪም
        </li>
      </ol>`,
      },
    },
    {
      title: "መግቢያ",
      details: {
        html: `
        <div class="chapter-content">
        <p style="padding-right: 10px;">
        በትምህርት ገበታ ላይ የሚገኙ ልጆች በት/ቤት ስለሚያጋጥማቸው ያልታሰበ የመውደቅ አደጋ፣ የመከላከያ ስልትና በቅድመ-ሆስፒታል የህክምና እርዳታ ላይ የሚያተኩር በዚህ ደረጃ የተዘጋጀ ትምህርት ሰጪ ጽሁፍ ስለሌለ ብዙ ልጆች ሲጎዱ ይስተዋላል። ስለዚህም ይህ ጥራዝ በተለያዩ ቋንቋዎች የተዘጋጀው ይህንን ክፍተት ከግምት ዉስጥ በማስተገባት የሚስተዋለዉን ችግር ለመቅረፍ ነው። ጥራዙ የተዘጋጀዉ በኢትዮጵያ እና በጋምቢያ “Bone Setting Associ- ated Disability (BOSAD)” የተሰኘ ሀገር አቀፍ ጥናት በማካሄድ ላይ በሚገኝ የባለሙያዎች ቡድን ነው፡፡ የጥናቱ ዓላማ የአጥንት እና መገጣጠሚያ ጉዳትን (muscu- loskeletal injury) በጨርቅ አጥብቆ በመጠቅለል፣ በቀርከሃ በማሰርና አስፈላጊ ባልሆነ ተደጋጋሚ ማሸት ምክንያት የሚከሰቱ ውስብስብ የጤና ችግሮችን ለመከላከል ነው፡፡ የዚህ የቦሳድ የምርምር ቡድን አጠቃላይ አላማው በሀገሪቱ ውስጥ ለአጥንት እና መገጣጠሚያ (musculoskeletal) ጉዳቶች የሚሰጠውን ሁለንተናዊ ህክምና ለማሻሻል ነው፡፡
        </p>
        <p style="padding-right: 10px;">
        ጥናቱ ባለፈው አንድ ዓመት ከስድስት ወር ሲካሄድ በቆየበት ወቅት በት/ቤት በመውደቅ የአካል ጉዳት የደረሰባቸው በርካታ ልጆች ነበሩ፡፡ እነዚህም ልጆች በአቅራቢያቸው ወደ ሚገኝ ባህላዊ የአጥንት ወገሻ ተወስደው የተጎዳው የአካል ክፍላቸው መታሸቱን፣ በቀርከሃ መታሰሩንና ከ7 እስከ 14 ቀናት ቤት እንዲቆዩ መደረጉ በዚሁ ወቅት ተረጋግጧል፡፡ ከዚያም በኋላ ህመሙ ሳይሻላቸው ሲቀርና ቤተሰብ ሁኔታው እየተባባሰ መሆኑን ሲያውቅ፣ ለተጨማሪ ምርመራና ህክምና ወደ ጤና ተቋማት ተወስደዋል፡፡ በጤና ተቋማቱ በተደረገው ምርመራም የተጎዳው የልጆቹ አካል ክፍል ታክሞ መዳን ወደ ማይችል ጋንግሪን ተቀይሮ ለአካል መቆረጥ ወይም ደግሞ ለእድሜ ልክ አካል ጉዳተኝነት የሚዳርግ ቋሚ የአካል መጉደል አብቅቷቸዋል፡፡ ይህ ሁኔታ እንደ አንድ የአጥንትና መገጣጠሚያ ሃኪም የእለት ከእለት ሥራዎቻችን ውስጥ የምንጋፈጠው መራራ እውነታ ነው፡፡
        </p>
        <p style="padding-right: 10px;">
        እነዚህ ልጆች ወድቀው ጉዳት እንደ ደረሰባቸው በጊዜ ወደ ጤና ተቋማት ተወስደው ተገቢዉ ህክምና ቢደረግላቸው ኖሮ፣ በአግባቡ ታክመው መዳንና በመልካም ጤንነት ወደ ትምህርት ገበታቸው በአጭር ጊዜ ዉስጥ መመለስ በቻሉ ነበር፡፡
        </p>
        <p style="padding-right: 10px;">
        ይህንን መረጃ ሰጪ አጭር ጥራዝ ለማዘጋጀት ያቀድንበት ዋናው ምክንያት፣ ስለችግሩ ግንዛቤ ለመፍጠርና በመውደቅ ምክንያት ለሚከሰት የአካል ጉዳት የመከላከያ ስልቶችን ለማመላከት ነው፡፡ አንዳንድ ጊዜ ከመውደቅ የተነሳ የሚመጣ ጉዳትን ሙሉ በሙሉ መከላከል ባይቻልም ከተከሰተ በኋላ ግን በተጎዳው ልጅ ላይ ተጨማሪ ጉዳት እንዳይደርስ መከላከል ይቻላል። ስለዚህ ልጆች በፍጥነት የሚያገግሙበትን ሁኔታ ለማመቻቸት ደህንነቱ የተረጋገጠ ህክምና ሊሰጥ ይገባል ይህ ጥራዝ በተጨማሪም የተጎዱ ልጆች ሆስፒታል ከመድረሳቸው በፊት መደረግ የሚገባቸዉን የተለያዩ የቅድመ ሆስፒታል የህክምና እርዳታዎችን የሚገልጽ ሲሆን፣ እነዚህን የህክምና እርዳታዎች መምህራን፣ የተማሪዎች ቤተሰብ እና ተማሪዎቹ ራሳቸው ማንበብ፣ መረዳትና በማንኛውም ጊዜ የመውደቅ አደጋ ሲያጋጥም በተግባር መጠቀም ይችላሉ፡፡
        </p>
        <p style="padding-right: 10px;">
        ሁላችንም እንደምናውቀው ልጆች ገና ለአካለ መጠን ያልደረሱ ባለ ለጋ ሰዉነት ናቸው፡፡ አካላዊና አእምሮአዊ የማመዛዘን ብቃታቸው ያልዳበረ በመሆኑ፣ በሌላ ሰዉ ላይ ጥገኛ የመሆን ደረጃቸዉ ከፍ ያለ ነዉ። በድርጊታቸው እና በአስጊ ባህርያቸውም ከአዋቂዎች በእጅጉ የተለዩ ናቸው፡፡ ለዚህም ነዉ ይህንን ራሱን የቻለ በመውደቅ አደጋ ምክንያት ልጆች በሚያጋጥሟቸዉ የአካል ጉዳቶች ላይ ያተኮረ አጭር ጥራዝ ለማዘጋጀት ያስፈለገው፡፡
        </p>
      </div>
      `,
      },
      image: "",
    },
    {
      title: `የጥራዙ ዓላማ`,
      details: {
        html: `
        <div class="chapter-content">
        <p style="padding-right: 10px;">
        የዚህ ጥራዝ ዋና ዓላማዉ በት/ቤት ዉስጥ በመውደቅ ምክንያት በልጆች ላይ የሚደርሱ ጉዳቶች በልጆቹ ላይ ስለሚያስከትሉት አስጊ ሁኔታዎች እና እንዴት መከላከል እንደሚቻል ለማመላከት የተዘጋጀ ነዉ። በተለይም በቅድመ-ሆስፒታል ደረጃ መከተል ስለሚገባን የህክምና እርዳታ ወይም የአያያዝ ስልት በተመለከተ በትምህርት ላይ ለሚገኙ ልጆች፣ ለቤተሰቦች፣ ለመምህራን፣ በት/  ቤት ውስጥ ለሚሠሩ የሚዲያ ባለሙያዎች እንዲሁም በአጠቃላይ ለሁሉም ማህበረሰብ መረጃዎችን ለመስጠት ታሳቢ ተደርጎ ነው፡፡ ጥራዙ በኢትዮጵያ ውስጥ በሚገኙ የተለያዩ ቋንቋዎች ተተርጉሞ ለት/ ቤቶች እና ከተቻለም ለወላጆች የሚሠራጭ ይሆናል፡፡
        </p>
      </div>`,
      },
    },
    {
      title: `ብያኔዎች`,
      details: {
        html: `
        <div class="chapter-content">
        <p style="padding-right: 10px;">
          <b>ልጆች:-</b> በዚህ ጥራዝ ውስጥ “ልጆች“ የሚለውን ቃል የተጠቀምነው ዕድሜያቸው ከ18 ዓመት በታች የሆኑትን ለመግለጽ ነው፡፡ በአጠቃላይ እስከ 12ኛ ክፍል ያለውን ትምህርት በመከታተል ላይ የሚገኙ ልጆች በሙሉ በዚህ ምድብ ሥር ተካተዋል፡፡
        </p>
        <p style="padding-right: 10px;">
          <b>መውደቅ ወይም በመውደቅ የሚከሰት ጉዳት:-</b> ሳይታሰብ የሰዉነት ወይም አካል ወደ መሬት፣ ወለል እና ወይም ደግሞ ከከፍታ ቦታ ዝቅተኛ ወደ ሆነው ደረጃ ማሽቆልቆል ሆኖ በግለሰቡ/ቧ ላይ ጉዳት ሊያስከትል የሚችል ሁነት ነዉ።
        </p>
        <p style="padding-right: 10px;">
          <b>ጉዳት ወይም የአካል መጎዳት:-</b> በዚህ ጥራዝ ውስጥ ጉዳት እና የአካል መጎዳት የሚለውን ቃል ተመሳሳይ እንደሆኑ አድርገን የተጠቀምን ሲሆን፤ ትርጉሙም ሳይታሰብ በአካል ላይ በሚደርስ ጫና ምክንያት የሚመጣን አካላዊ ጉዳት ለማለት ነው፡፡
        </p>
      </div>`,
      },
    },
    {
      title: `በትምህርት ገበታ ላይ ስላሉ ልጆች የመውደቅ አደጋን በተመለከተ መነጋገር ለምን አስፈለገ?`,
      details: {
        html: `
        <div class="chapter-content">
        <ol>
          <li>
          በዓለም ጤና ድርጅት ሪፖርት መሠረት፣ እስከ 18 ዓመት ባለው የዕድሜ ክልል ውስጥ በሚገኙ ልጆች ዘንድ አካላዊ ጉዳት ሞትና የእድሜ ልክ አካል ጉዳተኝነት ከሚያስከትሉ ሶስት ግንባር ቀደም መንስኤዎች ውስጥ አንዱ የልጆች የመዉደቅ አደጋ ነው፡፡
          </li>
          
          <li>
          ባላደጉ በርካታ ሀገራት ውስጥ የመውደቅ አደጋ እጅግ የተለመደ በድንገተኛ የህክምና ክፍሎች ውስጥ የሚታይ የልጅነት እድሜ ጉዳት ዓይነት ሲሆን፣ ከሁሉም የአካል ጉዳት መንስኤዎች ውስጥ ከ25-52% ድርሻ ይይዛል፡፡
          </li>
          
          <li>
          ለትምህርት ማቋረጥ ዋና ዋና ምክንያቶች ከሆኑት ውስጥ አንዱ ከመውደቅ ጋር የተያያዘ ህመምና ቋሚ የአካል ጉዳተኝነት ነው፡፡
          </li>
          <li>
          በመውደቅ ምክንያት የሚከሰት የአካል ጉዳት ረዘም ላለ ጊዜ የተኝቶና የተመላላሽ ህክምና የሚያስፈልገዉ በመሆኑ በቤተሰቦችም ሆነ በአጠቃላይ በህብረተሰቡ ላይ ከፍተኛ ማህበራዊና ኢኮኖሚያዊ ጫና እያስከተለ ይገኛል፡፡
          </li>
          <li>
          የመውደቅ አደጋ በዩናይትድ ስቴትስ ውስጥ በልጅነት እድሜ በአካል ጉዳት ምክንያት የሚከሰት ሞትን በማስከተል በአራተኛ ደረጃ እየመራ ይገኛል፡፡ ይህ ሁኔታ በሀገራችን ከዚህ 3 እጥፍ ከፍ ያለ በመሆኑ፣ ችግሩ ከዚህም የከፋ ይሆናል፡፡
          </li>
          <li>
          በኢትዮጵያ ውስጥ ካለን ልምድ፣ ልጆች የመውደቅ ጉዳት ከደረሰባቸው በኋላ ለውስብስብ ችግሮች መዳረጋቸውን ማየት እጅግ የተለመደ ነው፡፡ ባለፉት ሶስት ዓመታት በሀዋሳ ዩኒቨርሲቲ ውስጥ ከተከናወኑ በቀዶ ጥገና (ኦፕራሲዮን) የተጎዳ አካልን የማስወገድ/የመቁረጥ ሥራዎች ውስጥ ወደ 17% የሚጠጋው በልጆች ታካሚዎች ላይ የተሠራ ነዉ። ይህም የሆነዉ መለስተኛ የአካል ጉዳት ከደረሰባቸው በኋላ፤ ቤት ዉስጥ በጨርቅ ወይም መሰል ነገር ጠብቆ ተጠቅልሎላቸው ከቆየና ወደ የአካል መበስበስ (ጋንግሪን) ደረጃ ከተቀየረ በኋላ በመምጣታቸዉ ነው፡፡
          </li>
        </ol>
      </div>
          `,
      },
      image: 1,
    },
    {
      title: `ልጆች በት/ቤት ውስጥ ለምን ይወድቃሉ?`,
      details: {
        html: `
        <div class="chapter-content">
        <p>
        መውደቅ በአንድ ልጅ የእድገት ሂደት ውስጥ የተለመደ ነው፡፡ መራመድ መማር፣ የሆነ ነገር ላይ መውጣት፣ መዝለልና በአካባቢው ወዲያ ወዲህ በመዘዋወር መቃኘት አንድ ልጅ የሚያድግባቸው መንገዶች ናቸው፡፡ እንደ እድል ሆኖ በርካታ መውደቆች አነስተኛ ጉዳት የሚያስከትሉ ናቸው፡፡ በርካታ ልጆች በህይወት ዘመናቸው ብዙ ጊዜ የሚወድቁ ቢሆንም፣ ከአነስተኛ የአካል መቁሰል በስተቀር እምብዛም የከፋ የአካል ጉዳት ሲደርስባቸው አይታይም፡፡ በትምህርት ቤት ውስጥ ልጆችን በመውደቅ ምክንያት ለሚከሰት ጉዳት ሊያጋልጡ የሚችሉ አንዳንድ የተለዩ ሥፍራዎች ያሉ ሲሆን፣ ከእነዚህም መካከል የሚከተሉት ዋና ዋናዎቹ ናቸዉ።-
        </p>
        <ol>
          <li>
          ትናንሽ ልጆች ምናልባት ለልጅ እንክብካቤ መስጫ ከተዘጋጁ ቁሳቁሶች ለምሳሌ በልጆች ማቆያ ውስጥ ካለ ቁሳቁስ (nursery furniture) እና ከልጅ መረማመጃ (baby walker) ሊወድቁ ይችላሉ
          </li>

          <li>ሌሎች ደግሞ በልጆች መጫወቻ ሥፍራ ከሚገኙ ቁሳቁሶች ላይ ሊወድቁ ይችላል፡</li>

          <li>ከጣሪያ ላይ መውደቅ</li>

          <li>በሚያዳልጥ ወይም በረጠበ ሥፍራ በተለይም በዝናብማ ወቅቶች መውደቅ</li>

          <li>ደረጃዎችን ሲወጡ እና ሲወርዱ እንዲሁም ከተከፈተ መስኮት በመዝለል መውደቅ</li>

          <li>በትምህርት ቤት ውስጥ አዲስ ግንባታ በሚካሄድበት ሥፍራ መውደቅ</li>

          <li>በት/ቤት ውስጥ በፍሳሽ መሄጃ ቦዮች እና በውሃ ጉድጓዶች ውስጥ መውደቅ</li>

          <li>ስፖርታዊና የመዝናኛ እንቅስቃሴዎች ማለትም እግር ኳስ፣ መረብ ኳስ እና ሌሎችም</li>

          <li>ከዛፍ ላይ መውደቅ- ፍራፍሬ ለማውረድ ወይም እንዲሁ ለመጫወት ዛፍ ላይ ሲወጡ መዉደቅ</li>

          <li>
            ከጋማ ከብት ጀርባ ላይ ለምሳሌ ከፈረስ ወይም አህያ ላይ መውደቅ፡፡ በገጠር አካባቢ ልጆች ፈረስ ወይም አህያ
            ይጋልቡና ወድቀው ከተጎዱ በኋላ ሲመጡ ይታያል።
          </li>

          <li>
            በእድሜ አቻ ጓደኞቻቸዉ ተጠልፈዉ ወይም ደግሞ ተጠምዝዘዉ በመውደቅ መጎዳት በተለይ ተረከዝ አካባቢ በብዛት
            ይስተዋላል።
          </li>
          
        </ol>
      </div>
          `,
      },
      image: 2,
    },
    {
      title: `በመውደቅ የሚመጣ የአካል ጉዳት የሚያስከትላቸው ውጤቶች ምንድናቸው?`,
      details: {
        html: `
        <div class="chapter-content">
        <p>
        መውደቅ የሚያስከትላቸው አሉታዊ ውጤቶች በተለያዩ ሁኔታዎች ላይ የሚመሠረቱ ሲሆን፣ ይህም ለምሳሌ የህጻኑ ዕድሜ፣ የወደቀበት ከፍታ ወይም የጉዳቱ ሀይል፣ ጉዳቱ የደረሰበት ፍጥነት፣ የወደቀው ልጅ ያረፈበት መሬት ሁኔታ እና የጉዳቱ ባህርይ (አካል ቆስሎ ደም ወደ ውጭ መፍሰስ ወይም ወደ ዉጭ የማይደማ የዉስጥ ጉዳት) የሚያካትት ነው፡፡ እነዚህ ጉዳቶች የእድሜ ልክ አካል ጉዳተኝነት በማስከተል በቤተሰብና በአጠቃላይ በማህበረሰቡ ላይ ትልቅ ሸክም ይሆናል፤ አልፎ ተርፎም ሞትን ሊያስከትል ይችላል፡፡
        </p>
        <p>
          ከመውደቅ አደጋ የሚመጣ የጉዳት መጠን የሚከተሉትን ያካትታል:-
        <ol>
          <li>ራስን መሳት ሊያስከትል የሚችል አሰቃቂ የአንጎል ጉዳት</li>
          <li>የእድሜ ልክ አካል ጉዳት ሊያስከትል የሚችል የጀርባ አከርካሪ ጉዳት</li>
          <li>የአካል መቆረጥን ጨምሮ የእድሜ ልክ የአካል ጉዳት</li>
          <li>የእጅና እግር ስብራት</li>
          <li>ለኢንፌክሽን የሚያጋልጥ ክፍት ስብራት</li>
          <li>የእድገት አንጓ ጉዳት (Growth plate injury)፤ ይህም በጊዜ ካልታከመ በስተቀር የአጥንት መጉበጥ እና
            ቋሚ የአካል ጉዳት ሊያመጣ ይችላል፡፡</li>
          <li>የሆድ እቃና የዳሌ እንዲሁም የደረት አካባቢ ጉዳት</li>
          <li>ልክ እንደ አንድ ቋሚ የአካል ጉዳት የማይድን የመስማትና የማየት ችግር መከሰት</li>
          <li>በመጨረሻም በከፍተኛ ሀይል ከሚከሰት የአካል ጉዳት ወይም እጅግ ከፍታ ካለው ቦታ ከመውደቅ ጋር በተያያዘ ሞትም
            ሊያጋጥም ይችላል</li>
        </ol>
        </p>
      </div>
          `,
      },
      image: 3,
    },
    {
      title: `የመውደቅ አደጋን እና በድህረ-መውደቅ የሚከሰቱ ውስብስብ የጤና ችግሮችን እንዴት መከላከል ይቻላል?`,
      details: {
        html: `
        <div class="chapter-content">
        <p>አብዛኛዉን የጤና ነክ እክሎች እንዳይከሰቱ አስቀድሞ መከላከል እጅግ በጣም ወጪ ቆጣቢ
        የቁጥጥር ዘዴ ነዉ። ከዚህ በታች ለማሳየት የሞከርነው በት/ቤት ከመውደቅ ጋር የተያያዙ
        ከባድ የልጆች የአካል ጉዳትን ለመከላከልና ለሁሉም ወጪ ቆጣቢ ህክምና ለመስጠት መከናወን
        የሚገባቸዉን ተግባራት ነው፡፡</p>
        <ol>
          <li>በተቻለ መጠን ት/ቤቶች “ለልጆች ተስማሚ” የሆነ የት/ቤት ግቢ ማዘጋጀት
          ይኖርባቸዋል፡፡ ይህም ሲባል በጣም የዘመነ ህንጻ የሚፈልግ ሳይሆን፣ ግቢው ልጆቹ
          በቀላሉ ከቦታ ቦታ የሚንቀሳቀሱበትና ለጉዳት የማያጋልጣቸው መሆን ይኖርበታል
          ማለታችን ነው፡፡ ይህን ካደረግን ከመዋዕለ-ህጻናት ቁሳቁሶችና ከልጅ መንቀሳቀሻ
          ቁሳቁስ ላይ በመውደቅ የሚፈጠር የአካል ጉዳትን መቀነስ እንችላለን፡፡</li>
          <li>በት/ቤት ውስጥ የመጫወቻ ሥፍራዎች (የመወጣጫ፣ የመዝለያ እና የመንሸራተቻ ቁሳቁሶች) በሚዘጋጁበትና በሚተከሉበት
            ጊዜ፣ አገልግሎት መስጠት ከመጀመራቸው በፊት የደህንነት ደረጃ ግምገማ እና ማረጋገጫ ሊደረግላቸዉ ይገባል፡፡ ይህ
            ከተደረገ የትኛውም ልጅ አላስፈላጊ ለሆነ የመውደቅ አደጋና አካላዊ ጉዳት አይጋለጥም፡፡ ት/ቤቱ የመጫወቻ ሥፍራው
            በየጊዜው የሚጠግንበትን ሥርዓት ማበጀትና ለለጋ ልጆች ተቆጣጣሪዎችንም መመደብ ይኖርበታል፡፡ የመጫወቻዎች ከፍታ
            ለልጅ እድሜ የሚመጥን መሆን አለበት፡፡ ከመጫወቻዎች ዘለው ወይም ተንሸራትተው የሚያርፉበት የመሬት ሁኔታም የተስተካከለ፣ ለጉዳት
            የማያጋልጥና ልስላሴ ያለው ስለመሆኑ መፈተሸ ይኖርበታል፡፡</li>
          <li>ት/ቤቶች ክፍት የሆነ ጣሪያ እንዳይኖራቸው ይመከራል፡፡ ምናልባት ልጆች እዚያ ቦታ ሄደው በድንገት ሊወድቁ
            ይችላሉ፡፡ ድንገተኛ የልጆች መውደቅ እንዳይከሰት ለመከላከል፣ ጣሪያዎች፣ በረንዳዎችና ደረጃዎች ማገጃ እንዲኖራቸው
            እጅግ ይመከራል፡፡ በተጨማሪም ልጆች በት/ቤታቸው ቅጥር ግቢ ውስጥ ደህንነታቸውን ለመጠበቅ መፈጸም የሚገባቸውንና
            የማይገባቸውን እንዲያውቁ በሚኒ-ሚዲያ አማካይነት እንዲሁም ተማሪዎች ጧት ወይም ማታ በሚሰበሰቡበት ጊዜ ማስተማር
            አስፈላጊ ነው፡፡</li>
          <li>በት/ቤት ቅጥር ግቢ ዉስጥ የሚገኙ ውሃ አዘል ቦታዎችን ለምሳሌ ክፍት የውሃ መውረጃ ቦዮችንና ጉድጓዶችን
            በማስወገድ ግቢው በተቻለ መጠን ንጹህና ደረቅ መሆን ይኖርበታል፡፡ እነዚህ ክፍት የሆኑ ውሃ አዘል ቦታዎች በጣም
            አደገኛ ናቸው፡፡ ምክንያቱም ለመውደቅ መንስኤ ሊሆኑና ለህይወት አስጊ የሆነ ጉዳት በማንኛውም ሰው ላይ ሊያስከትሉ
            ይችላሉ፡፡ በመሆኑም በት/ቤት ግቢ ውስጥ ያሉ የውሃ ጉድጓዶችንና ቦዮችን በመክደን በተቻለ መጠን ምንም አይነት
            አዳላጭ የሆነ ቦታ እንዳይኖር ማድረግ እጅግ ወሳኝ ነው፡፡</li>
          <li>የልጆች መውጫ እና መዉረጃ ደረጃዎች ለጉዳት የማያጋልጡ መሆናቸው መረጋገጥ
          አለበት፡፡ ደረጃዎች ጉዳት ከማድረሳቸው አስቀድሞ አስፈላጊው ጥገና በየጊዜው
          መከናወን ይኖርበታል፡፡</li>
          <li>በት/ቤት ቅጥር ግቢ ውስጥ አዲስ ግንባታ በሚኖርበት ጊዜ፣ ተማሪዎች ወደዚያ
          እንዳይደርሱ በግልጽ የተከለከለ ሥፍራ መሆኑን በሚገልጽ የጽሑፍ ትዕዛዝ ማመላከት
          እንዲሁም ከተቻለ መከለል አለበት፡፡ ከዚህ በተጨማሪም ወደ ተከለከለው አደገኛ
          ሥፍራ የሚሄድ ተማሪ መኖር አለመኖሩን በየጊዜው የሚከታተል ተቆጣጣሪ መመደብ
          አስፈላጊ ነው፡፡</li>
          <li>በስፖርታዊ ወይም የመዝናኛ ተግባራት ጊዜ፣ ከፍተኛ የአካል ጉዳትን ለመቀነስ
          ተማሪዎች በእድሜ እኩያቸው ከሆኑ አቻዎቻቸው ጋር እንዲጫወቱ ይመከራል፡፡
          የመዝናኛ ሥፍራዎች መሬቱ የተስተካከለ መሆን ይኖርበታል፡፡ የሚቻልና ተግባራዊ
          የሚሆን ከሆነ ተማሪዎች በሚጫወቱበት ጊዜ የደህንነት መጠበቂያ ትጥቆችን ለምሳሌ
          የጉልበት ፓዶችን፣ የክርን ፓዶችን፣ የእጅ አንጓ ደህንነት መከላከያዎችን እንዲሁም
          የራስ ቅል መጠበቂያ ቆብ ሊጠቀሙ ይገባል፡፡</li>
          <li>አንዳንድ ልጆች ፍራፍሬዎችን ለመሰብሰብ ዛፎች ላይ ለመውጣት ሙከራ በማድረግ
          በድንገት ሊወድቁ ይችላሉ፡፡ ሌሎች ደግሞ ከአቻዎቻቸው ጋር ለመጫወት ብለው ዛፍ
          ላይ በመውጣት በእጅና እግራቸው ላይ ጉዳት ደርሶ ብዙውን ጊዜ እንደተለመደው
          ክፍት ስብራት ደርሶባቸው ሊመጡ ይችላሉ፡፡ ልጆች ዛፍ ላይ የሚወጡበት አላማ ምንም
          ይሁን ምን፣ በት/ቤት ተቆጣጣሪ ወይም በሌላ ሠራተኛ ቀጥተኛ ክትትል ሥር ሆኖ
          ለጉዳት የማያጋልጥ መሆኑ እስካልተረጋገጠ ድረስ ዛፍ ላይ መውጣት ለልጆች ክልክል
          መሆን ይኖርበታል፡፡</li>
          <li>ልጆች በተለይም ደግሞ ትንንሽ ልጆች ፈረስ ወይም አህያ እንዲጋልቡ መፈቀድ
          የለበትም፡፡ ከዚህ ጋር በተያያዘ ከወደቁ በኋላ የሚደርስባቸው የአካል ጉዳት ከባድ
          ሊሆን እንደሚችል እና ለሞት ወይም ለእድሜ ልክ የአካል ጉዳቶች ሊያጋልጣቸው
          እንደሚችል ትምህርትና ማስጠንቀቂያ ሊሰጣቸው ይገባል፡፡</li>
          <li>ልጆች በማወቅም ሆነ ባለማወቅ በመስኮት በኩል የመዝለል ሙከራ በማድረግ ለአካል
          ጉዳት እንዳይዳረጉ ለት/ቤት መስኮቶች በሙሉ ማገጃ ማበጀት ብልህነት ነው፡፡ በአሁኑ
          ጊዜ ለሁሉም የት/ቤት ተከፋች መስኮቶች ማገጃ ማበጀት እየተለመደ የመጣ በመሆኑ፣
          በመውደቅ ምክንያት የሚከሰቱ የአካል ጉዳቶችን በመቀነስ ረገድ የጎላ ሚና አለው፡፡
          </li>
        </ol>
      </div>
          `,
      },
      image: "4Amharic",
    },
    {
      title: `በት/ቤት ዉስጥ ወድቆ ጉዳት ለደረሰበት ልጅ የሚደረግ የቅድመ-ሆስፒታል ህክምና/አያያዝ`,
      details: {
        html: `
        <div class="chapter-content more">
        <p>አንድ ልጅ ወድቆ ጉዳት ከደረሰበት በኋላ በአካባቢው የሚገኝ ማንኛውም ሰው የህጻኑን ህይወት
        መታደግ አለበት፡፡ በተጨማሪም አካላዊ ጉዳትን ለመቀነስና ቋሚ የአካል ጉዳት እንዳይከሰት
        መከላከል ይገባል። ህመም ለመቀነስና የስነ-ልቦና ድጋፍ ለመስጠት እርምጃ መውሰድም አለበት፡፡</p>
        <p>
        ይህ ከላይ የዘረዘርንዉ ሁሉ “የመጀመሪያ ደረጃ እርዳታ” ብለን የምጠራው ሲሆን፣ የልጁን
        ህይወት ለመታደግና ከጉዳቱ የተነሳ የሚመጣን ውጤት በከፍተኛ መልኩ ለማሻሻል በጣም
        ጠቃሚ እርምጃ ነው፡፡
        </p>
        <p>ሁሉም ት/ቤቶች የመጀመሪያ ደረጃ እርዳታ መስጫ ማዕከላትና የሰለጠነ ባለሙያ ማዘጋጀት
        ቅድሚያ የሚሰጠው ጉዳይ ነው፡፡ ለዚህም የረቀቁ መሣሪያዎችንና ቁሳቁሶችን ማሟላት
        አያስፈልግም።
        </p>
        <p>
          ከዚህ በመቀጠል ወድቀው የአካል ጉዳት ለደረሰባቸው ተማሪዎች የተሳካ የመጀመሪያ ደረጃ እርዳታ ለመስጠት እንዲቻል
          የሚከተሉት ነገሮች መደረግ አለባቸው፡-</p>
        <ol>
          <li>በወደቀው/ችው ልጅ አካባቢ ያለ ሰው ሌሎች በአካባቢው የሚገኙ ሰዎች እንዲረዱት ለማንቃትና የሚቻለውን ህክምና
            ለልጁ/ለልጅቷ ለመስጠት የድረሱልኝ ጩኸት ማሰማት አለበት፡፡ ጩኸቱን እያሰማ የተጎዳውን ልጅ ባገኘው ነገር ለመርዳት
            ጥረት ማድረግ አለበት፡፡ እዚህ ጋር በመጀመሪያ ደረጃ እርዳታ መስጠት የሰለጠነ ሰው ካለ ወዲያውኑ ተጠርቶ በደቂቃዎች ውስጥ
            የህይወት አድን እርምጃዎች ማለትም ልጁን/ ልጅቷን በተገቢ አቀማመጥ ማኖር፣ የአየር መተንፈሻ ቱቦዉ በትክክል መስራቱን
            ማረጋገጥ፣ የአተነፋፈስ ስርዐቱን ማጤን እና ተጨማሪ መፍትሔ የሚያስፈልጋቸው ማናቸውንም ለህይወት አስጊ የሆኑ
            ሁኔታዎችን መፈተሸና ማስተካከል አለበት፡፡
          </li>
          <li>ለህይወት አስጊ የሆኑ ሁኔታዎች አለመኖራቸውን ካረጋገጥን በኋላ፣ በመቀጠል ሁሉንም የሰዉነት አካል የመፈተሸ
            (የመመርመር) ሥራ ማከናወን ይኖርብናል፡፡ በዚህ ወቅት ልጁን/ልጅቷን በተስተካከለ መሬት ላይ፣ ካለን ደግሞ
            በአከርካሪ መደገፊያ ቦርድ (spine board) ላይ በማስተኛት እና የትኛዉ የሰዉነት ክፍል እንደ ተጎዳ/ች ወይም
            ከፍተኛ ህመም እንደሚሰማው/ ሚሰማት መጠየቅ አለብን፡፡ ልጁ/ ልጅቷ ያልተናገረውን/ችውን የተደበቀ ጉዳት ለመለየት
            ከራስ ቅል እስከ እግር ጥፍር ድረስ ምርመራ ማድረግ ያስፈልጋል፡፡
          </li>
          <li>ለአጥንትና መገጣጠሚያ ጉዳት (musculoskeletal injury)፤ የእጅና የእግር ስብራት መኖር አለመኖሩን
            ያለ ራጅ በምርመራ ብቻ ለማወቅ፣ መርማሪው “እርግጠኛ የሆነ የስብራት ምልክቶች” በመባል የሚታወቁትን መጠቀም
            የሚችል ሲሆን፣ ይህም የሚከተሉትን የምርመራ ግኝቶች የሚያካትት ነው፡፡<br>
            <div>
            ሀ) በተጎዳው የሰዉነት አካል ላይ የሚሰማ ከፍተኛ ህመም<br>
            ለ) ካልተጎዳዉ እጅ ወይም እግር ጋር ሲነጻጸር በግልጽ የሚታይ የአካል ጥመትና ማጠር<br>
            ሐ) ከውጭ የሚታይ (ክፍት) ስብራት<br>
            መ) የተጎዳዉ ቦታ ሲንቀሳቀስ የሚዳሰስ ወይም የሚሰማ ድምጽ (ቋቋታ) (ነገር ግን ድምጽ ለመስማት ተብሎ የሚደረግ
            አላስፈላጊ እንቅስቃሴ የደም ቧንቧ እና ነርቭ ጉዳት ስለሚያስከትል መሞከር የለበትም)<br>
            ሠ) በተጎዳው የሰዉነት አካል ላይ ያለ ትክክለኛ ያልሆነ ንቅናቄ ወይም እንቅስቃሴ ናቸው፡፡ ልጁ/ልጅቷ ከላይ
            ከተጠቀሱት ውስጥ አንዱን እንኳን ካለው/ካላት፣ሁሉንም የመጀመሪያ ደረጃ እርዳታ አገልግሎቶች መስጠትና ወዲያውኑ ተገቢውን
            የአጥንት እና መገጣጠሚያ አገልግሎት ማግኘት ወደ ሚችልበት/የምትችልበት ቦታ መላክ ይኖርበታል/ይኖርባታል፡፡<br>
            </div>
          </li>
          <li>የጉዳቱ ቦታ ተለይቶ ከታወቀ በኋላ፤ ስብራት እና ዉልቃት ወይም ደግሞ የቆዳና ጡንቻ ጉዳት መኖሩ ጥርጣሬ ካለ፣
            ከት/ቤቱ ጉዳዩ የሚመለከተው ሰው የልጁን/ልጅቷን ቤተሰብ በአካል ወይም በስልክ ደዉሎ ማግኘትና ማናገር አለበት፡፡
            በዚህ መሀል ባለው ጊዜ የልጁ/ የልጅቷ የተጉዳው የአካል ክፍል እንዳይንቀሳቀስ ደግፎ ማቆየት ያስፈልጋል፡፡ የእጅና እግር ጉዳትን
            (limb injury) ለጊዜው ደግፎ ለማቆየት፣ በት/ቤቱ ቅጥር ግቢ ዉስጥ ያኘነውን ማንኛውንም ነገር ማለትም የልጁን/የልጅቷን
            ዩኒፎርም፤ ካርቶን፤ እና ማንኛዉንም ጨርቅ መጠቀም እንችላለን፡፡</li>
        </ol>
        
      </div>
          `,
      },
      image: 5,
    },
    {
      title: `የመዉደቅ አደጋ ለደረሰበት/ባት ልጅ የመጀመሪያ ደረጃ እርዳታ በሚሰጡበት ጊዜ ምን ማድረግ ይኖርብዎታል?`,
      details: {
        html: `
        <div class="chapter-content">
        <p>የመዉደቅ አደጋ የደረሰበትን/ባትን ልጅ የተጎዳውን የአካል ክፍሉን/ሏን ሳይነቃነቅ ደግፎ ለማቆየት አስፈላጊ የሆኑ
          ክንዉኖች በቅደም ተከተል ከዚህ በታች ቀርበዋል:-</p>
        <ol>
          <li>ማንኛውም የመድማት ሁኔታ ካለ፣ በመጀመሪያ እርዳታ መስጫ ኪት ወይም ሳጥን ውስጥ ባለው ፎጣ ደሙን ለማቆም ጥረት ያድርጉ፡፡ በኪቱ ውስጥ ምንም አይነት ጨርቅ ከሌለ ደሙን ለማቆም የልጁን/የልጅቷን ልብስ ወይም የት/ቤት የደንብ ልብሱን/ሷን መጠቀም ይችላሉ፡፡እዚህ ላይ ከኢንፌክሽን ይልቅ ደሙን ማቆም ቅድሚያ የሚሰጠው እርዳታ በመሆኑ በተገኘዉ ጨርቅ በመጠቀም የሚደማዉን ማቆም ያስፈልጋል። ፎጣ ሲጠቀሙ አጣጥፎ ማልበስ እና ሸብ አድርጎ ማስያዝ እንጂ የተጎዳዉን አካል ዙሪያዉን አይጠምጥሙ፡ የሚጠመጥሙት ከሆነ የሚደማውን አካል አንቆ በመያዝ ከተጎዳዉ የሰዉነት ክፍል በታች ያለዉን የደም ዝውውር ስለሚያቋርጥ ለከፋ ጉዳት ስለሚዳርግ ጥንቃቄ ያድርጉ። ደሙን ለማቆም ጥረት በሚያደርጉበት ጊዜ፣ በደም እንዳይበከሉ ለራስዎት የጥንቃቄ እርምጃዎችን ይከተሉ፡፡
          </li>
          <li>በተቻለ መጠን በተጎዳው የልጁ/የልጅቷ አካል ላይ ያሉ ጨርቆችን ወይም ልብሶች በሙሉ ያስወግዱ፡፡
          </li>
          <li>የአከርካሪ (የጀርባ) ጉዳት መኖሩ ጥርጣሬ ካለ፣ ህጻኑ ሆስፒታል ካልገባ እና ጉዳት እንደሌለዉ እስካልተረጋገጠ ድረስ፣ ምንም ሳይንቀሳቀስ ባለበት ድጋፍ መደረግ ይኖርበታል፡፡ ካንቀሳቀሱት ወይም ካገላበጡት አላስፈላጊ የሆነ ተጨማሪ የነርቨ ጉዳት ሊያስከትል ስለሚችል ጥንቃቄ ማድረግ ይገባል፡፡
          </li>
          <li>ግልጥ የሆነ የአካል መጣመም (deformity) ካልኖረ በስተቀር የተጎዳውን የአካል ክፍል አቀማመጥ ለመቀየር ወይም ለማስተካከል መሞከር የለብዎትም፡፡ ምክንያቱም ያልተገባ ተጨማሪ ጉዳት ሊያስከትልና ለህጻኑም እጅግ በጣም ህመምን የሚያመጣ ሊሆን ይችላል፡፡ ስለዚህ ባለበት ደግፈው እንዲቆዩ ይመከራል፡፡ ምናልባት የነርቭ ተግባርና የደም ዝውውር በአደጋዉ ምክንያት የተጎዱ እንደሆነ ማለትም ከጉዳቱ በታች ምንም አይነት እንቅስቃሴ ከሌለ፣ መነካካት የማይሰማዉ/ት ከሆነ፣ የደም ዝዉውሩ ከተስተጓጎለ የተጎዳውን የሰዉነት ከፍል ያለ ብዙ ንቅናቄ አቀማመጡን በመጠኑ በማስተካከል የነርቭ ተግባርና የደም ዝውውሩን እንዲስተካከል ማድረግ ይችላሉ፡፡
          </li>
          <li>የተጎዳውን አካል ባለበት ደግፈው ለማቆየት ሲሞክሩ፣ በአጠገብዎት ያለ ሌላ ሰው አካሉ እንዳይነቃነቅ በማድረግ እንዲረዳዎት ያድርጉ፡፡
          </li>
          <li>የተጎዳዉን አካል ለመደገፍ ማንኛዉንም ቀጥ ያለ ጠንካራ ነገር መጠቀም ይችላሉ፡፡ ይህም ጣዉላ፣ ካርቶን እና ጠንካራ ዱላዎች ሊሆኑ ይችላሉ፡፡ እዚህ ላይ እጅግ አስፈላጊው ነገር ለድጋፍ የሚጠቀሙትን ነገር ለተጎዳው አካል እንዲሆን መጠኑን ማስተካከል ያሻዎታል፡፡
          </li>
          <li>ድጋፍ በሚያደርጉበት ጊዜ ከተጎዳዉ አካል በላይ እና በታች ያሉ ሁለት መገጣጠሚያዎች ወይም በተጎዳው አካል አጠገብ ያለ አጥንት እንዳይንቀሳቀስ ጥረት ያደርጉ፡፡
          </li>

          <li>የተጎዳዉን አካል በሚያስሩበት ጊዜ መጠቅለያዉን አያጥብቁት ወይም ደግሞ አጥብቀዉ አይጠቅልሉት፡፡ ይህን ማድረግ የደም ዝውውር ላይ ተጨማሪ ጫና ያሳድራል፡፡
          </li>

          <li>ድጋፍ ሲያስቀምጡ የጉልበት መገጣጠሚያ ከ10-15 ድግሪ እንዲታጠፍ ያድርጉ፤ ቁርጭምጭሚት እና ክርን ደግሞ 90 ድግሪ ይሁን፤ እንዲሁም የዳሌ እና የእጅ አንጓ ቀጥ ይበል፡፡
          </li>

          <li>ድጋፉን ሳያጠብቁ በመጠቅለል ወይም ከተጎዳው አካል ጋር በማሰር አስተማማኝ እንዲሆን ያድርጉ፡፡ ድጋፉን አስተማማኝ ለማድረግ ከቦታው ያነሱትን ጨርቅ ወይም ልብስ መጠቀም ይችላሉ፡፡
          </li>
          <li>ከዚያም ልጁ/ልጅቷ በአቅራቢው ወደ ሚገኙ የጤና ተቋማት እንዲላክ/እንድትላክ ሁኔታዎችን ማመቻቸት ያስፈልግዎታል፡፡
          </li>
          <li>ልጁ/ልጅቷ ወደ ጤና ተቋም ሲላክ/ስትላክ ሲወድቅ/ስትወድቅ ያየ ሰው ወይም የመጀመሪያ ደረጃ ህክምና እርዳታ የሰጠው ሰው አጅቦ ቢሄድና በተቋሙ ላለ የጤና አገልግሎት ሰጪ ባለሙያ የተደረገዉን የመጀመሪያ ህክምና እርዳታ በማስረዳት ቢያሰረክብ መልካም ይሆናል፡፡</li>
        </ol>
      </div>
          `,
      },
      image: 6,
    },
    {
      title: `ለወደቀ/ች ልጅ የመጀመሪያ ደረጃ ህክምና እርዳታ በሚሰጡበት ጊዜ ማድረግ የሌለብዎት ነገር ምንድነው?`,
      details: {
        html: `
        <div class="chapter-content">
        <ol>
          <li>ከመውደቅ የተነሳ በልጆች ላይ የተከሰተን የአካል ጉዳት አቅልለው አይመልከቱ፡፡ ከከፍታ ቦታ የወደቁ ሁሉም ልጆች፣ በስፖርታዊ እንቅስቃሴ የደረሰ ጉዳት፣ በከፍተኛ ሀይል የደረሰ የአካል ጉዳት ከተከሰተ እና በተጎዳው ሥፍራ በሚሰማ ህመም ምክንያት ማልቀስ ወይም መነጫነጭ ከታየ ጉዳቱን እንደ ቀላል ማየት አይገባም። እንዲሁም ልጁ/ልጅቷ ወድቆ/ቃ ጉዳት ከደረሰበት/ባት በኋላ የሚያለቅስ/የምታለቅስ ከሆነ/ች፣  ጉዳቱ  እንደ  ቀላል  ተገምቶ  ወደ   ቤት መላክ  የለባቸውም፡፡  የልጆች  አጥንት  ተፈጥሮ  ከአዋቂዎች  የሚለይ  በመሆኑ፤
          <div><br>
            ሀ) የልጆች የእድገት አንጓ ጉዳት (growth plate injury)<br>
            ለ) የአጥንት ባንድ በኩል መሰበር (greenstick fracture)<br>
            ሐ) የአጥንት በከፊል መሰንጠቅ ጉዳት (torus fracture)<br>
            መ) የአጥንት መጣመም ወይም መጉበጥ (plastic deformity) የመጋለጥ እድላቸው ከፍተኛ ነው፡፡ ስለዚህ
            የአደጋዉ ሁኔታው በአጥንት እና መገጣጠሚያ የቀዶ-ህክምና ስፔሻሊስት ሐኪም ተመርምሮ ውሳኔ እስከሚያገኝ ድረስ፣ ይህ/ች
            ልጅ ስብራት እንዳጋጠመው/ማት ተደርጎ መወሰድ ይኖርበታል።<br>
            </div>
          </li>
          <li>ጉዳት የደረሰበትን የአካል ክፍል ማሸት፣ ማንቀሳቀስ ወይም ልጁን/ልጅቷን ባህላዊ የአጥንት ወገሻዎች መላክ በፍጹም
            አይገባም፡፡ የመዉደቅ አደጋ የደረሰባቸው ልጆች በሙሉ ተገቢውን ስልጠና በወሰደ የአጥንት እና መገጣጠሚያ
            የቀዶ-ህክምና ስፔሻሊስት ሐኪም መመርመር ይኖርባቸዋል፡፡ ልጆች በቀላሉ እንደ ጋንግሪን፣ የደም ስር ጉዳት፣ የአካል
            መጣመምና የመሳሰሉ ውስብስብ ችግሮች የተጋለጡ ናቸው፡፡ ከዚህ በተጨማሪም የልጆች ስብራት ተገቢ በሆነ መልኩ ራጅ
            (ኤክስ ሬይ) ካልተነሳ እና በሰለጠኑ የህክምና ባለሙያዎች ካልተመረመረ በስተቀር የስብራቱን አይነት ማወቅ እና
            መለየት አስቸጋሪ ነው፡፡ የተጎዳውን የልጅ አካል ክፍል ለማሸት ወይም ደግሞ ለማንቀሳቀስ መሞከር አንድ ሰው
            በህይወት ዘመኑ ከሚያጋጥሙ ህመሞች ሁሉ የከፋ ህመም የሚያመጣ ተግባር ነው፡፡ልጆች በሚታሹበት ጊዜ በሚሰማቸዉ ህመም
            ምክንያት ራሳቸዉን ሊስቱ ስለሚችሉ ከእንደዚህ አይነቱ ተግባር መቆጠብ ያስፈልጋል፡፡
          </li>
          <li>የጠበቀ መጠቅለያ አይጠቀሙ፡፡ የተጎዳን የአካል ክፍል (እጅና እግር) በጨርቅ አጥብቀው በሚያስሩበት ጊዜ የደም
            ዝውውር የበለጠ እንዲገታ በማድረግ ወደ ጋንግሪን ይቀይራል፡፡ በመሆኑም የተጎዳውን አካል ለመደገፍ የምንጠቀመው
            ድጋፍ በሙሉ ከተቻለ ዙሪያውን ዞሮ የሚታሰር መሆን የለበትም፡፡ አካሉን ደግፎ እንዲይዝ ብቻ ላላ መደረግ
            አለበት፡፡
          </li>

          <li>ደም ለማቆም ጥምጣም (tourniquet) አይጠቀሙ፡፡ ደም ለማቆም ሲባል በተጎዳው አካል ላይ ጥምጣም መጠቀም
            በደም ዝውውር ላይ ጫና ያሳድራል፡፡ ስለዚህ የሚፈስ ደም ለማቆም ሲያስቡ ጨረቅ በመደራረብ መሸፈንና የተጎዳውን እጅ
            ወይም እግር ወደ ላይ ከፍ የሚያደርግ ነገር ብቻ ይጠቀሙ፡፡ ከዚያም ተጎጂውን/ዋን ልጅ ወደ ጤና ተቋማት በአፍጣኝ
            ይላኩ፡፡</li>
        </ol>
      </div>
          `,
      },
      image: 7,
    },
    {
      title: `የወደቀን/ችን ልጅ በማን፣ መቼ እና እንዴት ወደ ጤና ተቋማት ይላካል?`,
      details: {
        html: `
        <div class="chapter-content">

        <p>ወድቆ/ቃ የአካል ጉዳት የደረሰበት/ባት እና ከሚከተሉት ውስጥ አንዱ ያጋጠመው/ያጋጠማት ልጅ ወዲያውኑ ወደ ጤና ተቋማት
          መላክ ይኖርበታል/ባታል፡-</p>
        <ol>
          <li>ጉዳቱን ተከትሎ ማንኛውም አይነት የሚደማ ቁስል ካለ</li>
          <li>ከላይ የተጠቀሱት “እርግጠኛ የስብራት ምልክት” ካለ</li>
          <li>የትኛውም የአካል ክፍል ጉዳት እንዳጋጠመው/ማት ጥርጣሬ ካለዎት</li>
          <li>በተጎዳው የሰዉነት ክፍል ላይ ህመም እና እብጠት ካለ</li>
          <li>የተጎዳውን እጅ ወይም እግር ለመጠቀም ወይም ለማንቀሳቀስ አስቸጋሪ ከሆነ</li>
          <li>ትንንሽ ልጆች ከሆኑ፣ ጉዳቱ ከደረሰባቸው በኋላ አምርረው የሚያልቅሱ ከሆነ</li>
           <p>ወድቀው ጉዳት የደረሰባቸዉን ልጆች
            የሪፌራል ጊዜ በተመለከተ ጉዳቱ በተከሰተበት ቦታ ላይ የመጀመሪያ ደረጃ ህክምና
            እርዳታ ተሰጥቷቸው ለተወሰነ ግዜ ክትትል ይደረግላቸዋል፤ ከዚያ በኋላ ጉዳቱ ቀላል ሳይሆን ቀርቶ ልጁ/ ልጅቷ ወደ
            ሥራው (ትምህርት ወይም ጨዋታዉ) መመለስ ካልቻለ/ች፣ ወዲያውኑ አቅራቢያዉ ወደሚገኝ የጤና ተቋም ሪፈር ማድረግ ይገባዎታል፡፡
            ልጁ/ ልጅቷ ከጉዳቱ በኋላ ሪፈር ከተደረገ/ች፣ የጉዳቱ መጠን ተመርምሮ አስፈላጊው ህክምና ይደረግለታል/ላታል። ስለዚህ እባክዎን ጉዳት
            የደረሰባቸዉን ልጆች በእጅዎ ላይ እንዲዘገዩ አያድርጉ፡፡</p>
            <p>ወድቀው ጉዳት የደረሰባቸዉን ልጆች እንዴት ሪፈር እንደሚደረጉ በተመለከተ፣ መጀመሪያ የህጻኑን ህይወትና የተጎዳውን
            የአካል ክፍል ለማዳን የተቻለው የመጀመሪያ ደረጃ ህክምና እርዳታ በሙሉ በት/ቤትዎ ደረጃ መሰጠት ይኖርበታል፡፡
            በመቀጠልም የልጁ/ልጅቷ ቤተሰብ ስለሁኔታው እንዲያውቅ ተደርጎ ልጁ/ልጅቷ ከቤተሰብ ወይም ከአሳዳጊ ጋር ወደ ጤና ተቋም
            መወሰድ አለበት/አለባት፡፡ ልጁን/ልጅቷን ለጤና ተቋም ለማሰረከብ አንድ የት/ቤቱ ተወካይም አብሮ መሄድ አለበት፡፡</p>
        </ol>
      </div>
          `,
      },
      image: "8Amharic",
    },
    {
      title: `ወሳኝ የአካል ጉዳት አያያዝ ተግባራት ምንድናቸው?`,
      details: {
        html: `
        <div class="chapter-content">
        <p>ወድቆ የተጎዳ ልጅ ሲያጋጥም፣ ተገቢው ህክምና እዚያው ጉዳቱ በተከሰተበት ቦታ ላይ እንደማንኛው የአካል ጉዳት ሰለባዎች መሰጠት መጀመር አለበት፡፡ ከዚያም ልጁ ወደ ተገቢዉ የጤና ተቋማት መዛወርና መደበኛ የሆኑ ነገሮች በሙሉ መሰጠት ያለባቸው ሲሆን እነዚህም የሚከተሉትን ዋና ዋና ተግባራት ያካትታል።</p>
        <ol>
          <li>ልጁን ለህይወት የሚያሰጋ ጉዳት መኖር አለመኖሩ ተመርምሮ በዚያው መሰረት አያያዝ ይደረጋል፡፡ ለማንኛው የአካል ጉዳት ታካሚ የሚደረግ የህክምና ስልት “የተቀናጀ የከባድ አደጋዎች የህይወት አድን” መመሪያዎችን ይከተላል፡፡
          </li>
          <li>በመቀጠል የጉዳቱን አይነት መሠረት በማድረግ፣ የተለያዩ ህክምናዎች ማለትም የህመም ማስታገሻ መድሃኒት፣ እንፌክሽን መድሃኒት (ጸረ ተህዋሲያን)፣ የቴታነስ መድሃኒት እና የማንቀጥቀጥ (ለሚጥል በሽታ የሚሰጥ መድሃኒት) ህክምና በምርመራ በተገኘዉ ዉጤት መሠረት ይሠጣል፡፡
          </li>
          <li>ቁስል ካለ መድማቱን ካስቆመን በኋላ የቁስል ማመርቀዝ በማይፈጥር መንገድ ጸድቶ ከበካይ ተህዋስያን ነጻ በሆነ መጠቅለያ ይሸፈናል፡፡
          </li>
          <li>ግልጽ የሆነ የተጎዳዉ አካል መጣመምና የመገጣጠሚያ መዉለቅ በሚያጋጥምበት ጊዜ ህጻኑ ከህመም ነጻ እንዲሆን በቂና ተገቢው የህመም ማስታገሻ መድሃኒት ከተሰጠዉ በኋላ የሚስተካከል ወይም ደግሞ ወደ ቦታዉ የሚመለስ ይሆናል፡፡ ይህ ችግር ያጋጠመዉ ህጻን ምንም አይነት መድሃኒት ባልተሰጠበት ሁኔታ ግን ለማስተካከል መሞከር በፍጹም የተከለከለ እና ለባሰ ችግር የሚያጋልጥ በመሆኑ ጉዳቱ በደረሰበት ቦታም ሆነ በጤና ተቋማት መሞከር የለበትም።
          </li>
          <li>ለተጎዳው የአካል ክፍል አስፈላጊ የሆኑ የህክምና መርሆዎችን በመከተል ግዚያዊ የአካል ድጋፍ ይበጅለታል፡፡
          </li>
          <li>በመቀጠልም ታካሚው ልጅ ለተገቢ የራጅ (ኤክስ ሬይ) ምርመራ ይላካል፡፡ እዚህ ላይ ማወቅ ያለብዎት እጅግ አስፈላጊው ነገር በልጆች ላይ የሚከሰት ስብራት አዋቂዎች ላይ ከሚከሰተው ስብራት በእጅጉ የሚለይ መሆኑንና ጉዳቱን ለመመርመር የምናነሳዉ ኤክስ ሬይም የሚለይ እንደሆነና ስለችግሩ የሚሰጠው ገለጻም ጥንቃቄ የተሞላበት ምርመራ የሚያስፈልገው መሆኑን ነው፡፡ ስለዚህ ማንም ኤክስ ሬይ ማየት የሚችል ሰው የሁሉንም ልጅ ስብራት የምርመራ ውጤት በቀላሉ ሊለይ አይችልም፡፡ ይህንን ለማወቅ እና በጥንቃቄ ለመለየት በዘርፉ ባለሙያ መሆንን ይጠይቃል፡፡ ስለሆነም በዘርፉ ስልጠና ሳይወስዱ ራጅ በማዘዝ የማያዉቁትን የሚያነቡ በመምሰል ልጆችን በተደጋጋሚ በማሸት እና አጥብቆ በማሰር ለአላስፈላጊ ችግር የሚያጋልጡ በርካታ የሰፈር ወገሻዎች ስለተበራከቱ ወላጆች ለልጆቻቸዉ የሚሰጠዉን ህክምና በሚመለከተዉ በሰለጠነ የህክምና ባለሙያ መሆኑን የማረጋገጥ ሃላፊነትና ግዴታ ይኖርባቸዋል።
          </li>
          <li>የጠቅላላ ምርመራ እና የኤክስ ሬይ ውጤትን መሠረት በማድረግ ለልጁ የሚያስፈልገው ወሳኝ ህክምና በተመለከተ ከቤተሰብ ወይም ከአሳዳጊ ጋር የህክምና አማራጮቹ ላይ ውይይት ይደረጋል። ከዚያም የመጨረሻ ህክምናዉ በሚመለከተዉ ባለሙያ የሚሰጥ ይሆናል።
          </li>
          <li>በአጠቃላይ በልጆች ላይ የሚከሰቱ በርካታ የአካል ጉዳቶች ያለ ቀዶ-ህክምና ዘዴ የሚታከሙ ናቸው፡፡ ይህን ታዲያ በአግባቡ ለመተግበርና ውጤቱም መልካም እንዲሆን የሰለጠነ የህክምና ባለሙያ ይፈልጋል፡፡ የቅርብ ክትትል ማድረግም እንዲሁ ወሳኝ ነገር ነው፡፡ ወድቀው ጉዳት የደረሰባቸዉን ልጆች የተሳለጠ ህክምና የሚደረግበት አጠቃላይ አላማው ችግሩን በጊዜ ለመለየትና ለማከም፣ በፍጥነት እንዲያገግሙና ወደ ትምህርት ገበታቸው በተቻለ ፍጥነት እንዲመለሱ ለማስቻል ነው፡፡ እነዚህን ከላይ የዘረዘርናቸዉን ተግባራት በሙሉ በአግባቡ በማከናወን የመዉደቅ አደጋ ያጋጠማቸዉ ልጆች ዘንድ የሚስተዋለዉን ከትምህርት የማቋረጥና ከትምህርት ቤት የመቅረት ችግሮችን በተጨባጭ መቀነስ ይቻላል፡፡
          </li>
        </ol>
      </div>
          `,
      },
      image: 9,
    },
    {
      title: `ዋቢዎች`,
      details: {
        html: ` 
        <div class="chapter-content">
        <ol>
          <li>World Health Organization (WHO).Injuries and Inequities-Guidance forAddressing Inequities in unintention-al Injuries. Copenhagen, Denmark:World Health Organization RegionalOfﬁce for Europe; 2014</li>
          <li>CDC, Injuries among Children andTeens report, https://www.cdc.gov/injury/features/child-injury/index.html</li>
          <li>Chapman RL, Buckley L, SheehanM, Shochet IM. Pilot evaluation ofan adolescent risk and injury pre-vention programme incorporatingcurriculum and school connected-ness components. Health Educ Res.2013;28(4):612–625</li>
          <li>James S.L, Lucchesi L.R,  BisignanoC,  Castle C.D,  Dingels Z.V,  et al.The global burden of falls: Global, re-gional and national estimates of mor-bidity and mortality from the GlobalBurden of Disease Study 2017. InjuryPrev. 2020, 26 (Suppl. 1), i3–i11</li>
          <li>Amy E Peden, Richard C Franklin,Child Injury Prevention: Is it time toaddress the determinants of Health.Children, 2021, 8:46.</li>
          <li>International Federation of Red crossand Red crescent Societies, Interna-tional First aid and Rescessitationguidelines, 2016</li>
          <li>Meghalaya State Disaster Man-agement Authority, Basic First AidManual, India, 2014</li>
          <li>Blake G, Velikonja D, Pepper V,Jilderda I, Georgiou G. Evaluating an in-school injury preventionprogramme’s effect on children’shelmet wearing habits. Brain Inj.2008;22(6):501–507</li>
          <li>Pickett, W.; Molcho, M.; Simpson,K.; Janssen, I.; Kuntsche, E.; Ma-zur, J.; Harel, Y.; Boyce, W.F. Crossnational study of injury and socialdeterminants in adolescents. InjuryPrev. 2005, 11, 213–218</li>
          <li>Lama Bou-Karroum, Fadi El-Jardali,Mathilda Jabbour, Aya Harb, RachaFadlallah, et al, Preventing Unin-tentional Injuries in School-AgedChildren: A Systematic Review.Paediatrics, 2022, 149:6</li>
          <li>UNICEF. Levels & Trends in ChildMortality Report 2019. New York,NY: UNICEF; 2020</li>
          <li>Jamison DT, Breman JG, MeashamAR, et al. Disease Control Prioritiesin Developing Countries. Washing-ton, DC: The World Bank; 2006</li>
          <li>Barcelos RS, Del-Ponte B, SantosIS. Interventions to reduce accidentsin childhood: a systematic review. JPediatr (Rio J). 2018;94(4):351–367</li>
          <li>Mytton J, Towner E, Brussoni M,Gray S. Unintentional injuries inschool-aged children and adolescents:lessons from a systematic review ofcohort studies. Inj Prev.2009;15(2):111–124</li>
          <li>Mock CN, Smith KR, Kobusingye O,et al. Injury Prevention and Environ-mental Health: Key Messages. 3rded. Disease Control Priorities. Vol 7.Washington, DC: The World Bank;2017</li>
          <li>Nauta J, van Mechelen W, OttenRHJ, Verhagen EALM. A system-atic review on the effectivenessof school and community-basedinjury prevention programmes onrisk behaviour and injury risk in 8-12year old children. J Sci Med Sport.2014;17(2):165–172</li>
          <li>Kendrick D, Mulvaney CA, YeL, Stevens T, Mytton JA, Stew-art-Brown S. Parenting interventionsfor the prevention of unintentionalinjuries in childhood. Cochrane Data-base Syst Rev. 2013;(3)</li>
          <li>Towner E, Dowswell T, Jarvis S.Updating the evidence. A systematicreview of what works in preventingchildhood unintentional injuries: part1. Inj Prev. 2001;7(2):161–164</li>
          <li>Kendrick D, Young B, Mason-JonesAJ, et al. Home safety education andprovision of safety equipment forinjury prevention. Cochrane DatabaseSyst Rev. 2012;(9)</li>
          <li>Pearson M, Garside R, Moxham T,Anderson R. Preventing unintentionalinjuries to children in the home: asystematic review of the effective-ness of programmes supplying and/or installing home safety equipment.Health Promot Int. 2011;26(3):376–392</li>
          <li>Pearson M, Hunt H, Garside R, Mox-ham T, Peters J, Anderson R. Prevent-ing unintentional injuries to children under 15 years in the outdoors: asystematic review of the effectivenessof educational programs. Inj Prev.2012; 18(2):113–123</li>
          <li>Orton E, Whitehead J, Mhizha-Mu-rira J, et al. School-based educationprogrammes for the prevention ofunintentional injuries in children andyoung people. Cochrane DatabaseSyst Rev. 2016;(12):CD010246</li>
          <li>Morrongiello BA, Lasenby-LessardJ. Psychological determinants of risktaking by children: an integrativemodel and implications for interven-tions. Inj Prev. 2007;13(1):20–25</li>
          <li>DelCastillo-Andres O, Toronjo-Hor-nillo L, Toronjo-Urquiza L. Effectsof fall training program on autom-atization of safe motor responsesduring backwards falls in school-agechildren. Int J Environ Res PublicHealth. 2019;16(21)</li>
          <li>WHO, Falls, Key facts, 2021, https://www.who.int/news-room/fact-sheets/detail/falls</li>
        </ol>
      </div>
        `,
      },
    },
  ];
  return result;
};
